import Vue from 'vue'
import Moment from 'vue-moment'

Vue.use(Moment);
